export interface ICardTableGroup {
  cardTableGroupId?: string;
  defaultApplication?: string;
  dualBrandDetails?: {
    localBrands: string[];
    defaultBrands: string[];
  };
}
